import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { FormlyService } from '../../../../tms-shared';
import { RoleService } from '../../services';

@Component({
  selector: 'app-role-details',
  templateUrl: './role-details.component.html',
  styleUrl: './role-details.component.scss',
})
export class RoleDetailsComponent implements OnInit {
  @Output() saved = new EventEmitter<void>();

  fields: FormlyFieldConfig[];

  constructor(
    public roleService: RoleService,
    private formlyService: FormlyService,
  ) {}

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = this.formlyService.oneColumnGrid([
      this.formlyService.text('name', $localize`Name`, undefined, { required: true, maxLength: 256 }),
      this.formlyService.text('description', $localize`Description`, undefined, { required: true }),
      this.formlyService.checkbox('showSettings', $localize`Show Settings`),
    ]);
  }
}
